import { useTemplate } from '#~/device/registry/hooks.js';
import { dequal } from 'dequal';
import { useEffect, useRef } from 'react';
import { resolveProtocolSettings } from '../../add/control/normalize.js';
import { useProducer, useStore } from '../store/hooks.js';

/** Keep the driver configuration available across settings tabs. */
export const useDriverTemplate = (): void => {
  const producer = useProducer();
  const modelId = useStore((state) => state.candidate.modelId);
  const config = useTemplate(modelId);
  const appliedModelId = useRef(modelId);

  useEffect(() => {
    producer((draft) => {
      draft.manufacturer.config = config;
      draft.manufacturer.isOther = !!config?.model.name.toLowerCase().includes('other');

      // Loading a saved driver or receiving an outdated template must not reset custom settings.
      if (!config || config.model.id !== modelId || appliedModelId.current === modelId) return;
      appliedModelId.current = modelId;
      if (dequal(draft.candidate, draft.lifecycle.snapshot)) return;

      const protocol = config.control?.protocol;
      if (!protocol) return;

      const { control, video } = draft.candidate;
      const credentials =
        (control && 'credentials' in control ? control.credentials : undefined) ??
        (video && 'credentials' in video ? video.credentials : undefined);
      // Keep camera identity/authentication, but take protocol-specific ports from the new driver.
      draft.candidate.control = resolveProtocolSettings(
        protocol,
        { credentials },
        config,
        video && 'host' in video ? video : control
      );
      draft.control.cache = {};
    });
  }, [config, modelId, producer]);
};
